

import wx from 'weixin-js-sdk';
import cmBlank from '@/components/cmBlank.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import PopupHeader from 'vux/src/components/popup-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

export default {
name: 'ironing',
components: {
wx,XTextarea,Group,Popup,PopupHeader,XButton,Radio,cmBlank,TransferDom
},
directives: {
TransferDom
},
data () {
return {
backPop:false,
pickerStatus:false,
blankShow:false,
popBg:false,
platform_id:1,
platform_title:'蜂潮洗衣',
platform:[],
id:0,
code:'',
code1:'',
content:'',
title:'成品出厂',
type:0,
order:{},
pageFlag:2,
hasNext:0,
lastId:0,
list:[],
}
},
created(){
this.config();
this.platform = this.$func.platform;
},
mounted(){
},
methods:{
copy(val){
this.$func.copy(val,event);
},
getList(){
this.$api.operateRecordList({code:this.code1,last_id:this.lastId,page_flag:this.pageFlag,title:this.title,platform_id:this.platform_id}).then((res)=>{
if(res){
if(!this.lastId){
this.blankShow = res.data.length > 0 ? false : true;
}
this.hasNext = res.hasNext;
this.lastId = res.lastId;
res.data.forEach((item)=>{
this.list.push(item);
});
}
})
},
onChange (value) {
let that = this;
this.platform_id = value;
this.platform.forEach((item)=>{
if(item.key == this.platform_id){
that.platform_title = item.value;
return;
}
})
this.search();
console.log(value);
},
scanQRCode(type){
let that = this;
this.type = type;
wx.ready(()=> {
wx.scanQRCode({
needResult: 1,
scanType: ["barCode"],
success: function (res) {
setTimeout(()=>{
if(type == 2){
that.code1 = that.$func.parseScanResult(res.resultStr);
that.search();
}else{
that.code = that.$func.parseScanResult(res.resultStr);
that.submit();
}
},300);
}
})
});
wx.error((res)=> {
console.log(res)

})
},
search(){
this.type = 0;
this.list = [];
this.lastId = 0;
this.hasNext = 0;
this.getList();
},
barCode(code){
this.$router.push({name:'barOrder',params:{code:code}})
},
copy(val){
this.$func.copy(val,event);
},
closePop(){
this.popBg = false;
this.backPop = false;
this.type = 0;
},
openPop(){
this.popBg = true;
this.backPop = true;
},
config(){
let url = (window.location.href).split('#');
if(url[0].indexOf('?') != '-1'){
url = url[0].split('?');
}
this.$api.wxSign({url:url[0]}).then((res)=>{
if(res){
wx.config({
debug: false,
appId: res.data.appId,
timestamp: res.data.timestamp,
nonceStr: res.data.nonceStr,
signature:res.data.signature,
jsApiList: [
"scanQRCode"
]
});
}
})
},
submit(){
let that = this;
if(!this.code){
that.$func.showToast('衣物条码无效');
return ;
}
this.$api.addOperateRecord({code:this.code,title:this.title,content:this.content}).then((res)=>{
if(res){
that.$func.showToast('操作成功');
this.code = '';
this.content = '';
this.order = {};
wx.ready(function () {
let media = document.getElementById("musicBox");
media.src = "https://fcwash.uunbiot.com/uploads/default/operate.mp3"
media.play();
});
if(that.type == 1 ){
setTimeout(() => {
that.scanQRCode(that.type);
}, 300);
}
}
})
},
loadmore(){
if(this.lastId > 0 && !this.hasNext){
this.busy = true;
this.loadStatus = true;
this.loadmoreText = '没有更多了。。。'
return ;
}
this.busy = true;
this.loadStatus = true;
this.loadmoreText = '正在加载。。。';
this.getList();
setTimeout(()=>{
if(this.blankShow){
this.busy = true;
this.loadStatus = false;
this.loadmoreText = '没有更多了。。。'
}else{
if(this.hasNext > 0){
this.loadStatus = false;
this.busy = false;
}else{
this.busy = true;
this.loadStatus = true;
this.loadmoreText = '没有更多了。。。'
}
}
},1500)
}
}
}



// WEBPACK FOOTER //
// ./src/pages/finisheOutFactory.vue